@if (dashboardMenu) {
  <div>
    @for (group of dashboardMenu.groups; track group) {
      @if (group != null) {
        <div>
          @if (!isOffline || group.title) {
            <h2 class="title h2">{{group.title}}</h2>
          }
          <div class="card-deck" [ngClass]="{ 'card-deck-compressed': useCompressedLayout }">
            @for (item of group.items; track item) {
              <div class="card course-card">
                <div class="card-body">
                  <div class="title" [ngClass]="{ 'h4': !useCompressedLayout }">
                    @if (!isWorkingOffline && item.isConnectUsLink) {
                      <a class="link" [routerLink]="[item.link]"> {{item.text}} </a>
                    }
                    @if (!isWorkingOffline && !item.isConnectUsLink) {
                      <a class="link" href="{{item.link}}">{{item.text}}</a>
                    }
                    @if (isWorkingOffline) {
                      <span>{{item.text}}</span>
                    }
                  </div>
                  <div class="button">
                    @if (!isWorkingOffline && item.isConnectUsLink) {
                      <a class="btn btn-primary" [routerLink]="[item.link]" role="button" aria-label="load button">
                        <span class="icon-gecko-direction-right"></span>
                      </a>
                    }
                    @if (!isWorkingOffline && !item.isConnectUsLink) {
                      <a class="btn btn-primary" href="{{item.link}}" role="button" aria-label="load button">
                        <span class="icon-gecko-direction-right"></span>
                      </a>
                    }
                    @if (isWorkingOffline) {
                      <span class="btn btn-primary disabled" role="button" aria-label="load button disabled"
                        >
                        <span class="icon-gecko-direction-right"></span>
                      </span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
}